var styles = {"informationCard":"styles_information-card__fJWDD","coloredBackground":"styles_colored-background__qae70","accent":"styles_accent__vOjjV","complement1":"styles_complement-1__YwyP8","complement2":"styles_complement-2__C7EDb","complement3":"styles_complement-3__acwsN","labelContainer":"styles_label-container__1nJgf"};

export { styles as default };
//# sourceMappingURL=styles.css.js.map
